import './mustardseed/style';
import FormStructure from './mustardseed/form_structure';

export default FormStructure;